import React, { useCallback, useEffect, useRef, useState, useContext } from 'react';
import style from "./MapSearch.module.scss";
import { GoogleMap } from '@react-google-maps/api';
import AppConfig from '../../../AppConfig';
import IconButton from '@mui/material/IconButton';
import "react-day-picker/dist/style.css";
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import allStyle from "./../all.module.scss";
import PotItem from './PotItem';
import PotSwipe from './PotSwipe';
import PotViewItem from './PotViewItem';
import Close from '@mui/icons-material/Close';
import { getDistance, checkGeocodingAPI, geocodeLatLng, getAdministrativeArea, getGeocodingData, getCountyAndTownForAddr } from '../../comm';
import * as YStyle from "../../../Styleds";
import apiManager from '../../../ApiManager';
import { usePlacesAutocomplete } from '../usePlacesAutocomplete';
import { CustomEventManager } from "../CustomEventManager";
import { GameContext } from "../../../GameContext";
const customEventManager = new CustomEventManager();
/* 
type: tab0 , selPot */
const MapSearch = ({ addModalType, set_menuVisiable, pageState, set_pageState, potIndex, set_potIndex, type, isFullScreen, onPot, onSave }) => {
    const { rankRewilding, rewilding } = useContext(GameContext);
    const [pots, set_pots] = useState([]);
    const [selectCustomPosition, set_selectCustomPosition] = useState(null);
    const selectPositionMarker = useRef(null);
    const searchBarInitStr = '想去哪?';
    const [searchBarDefaultStr, set_searchBarDefaultStr] = useState(searchBarInitStr);
    const previousSelectedMarker = useRef(null);
    const radius = useRef(1000);
    const markersRef = useRef(null);
    const [tags, set_tags] = useState([]);
    const [newPot, set_newPot] = useState(null);
    const [keyword, set_keyword] = useState("");
    const { predictions, searchPredictions, getPlaceDetails, searchNearby } = usePlacesAutocomplete();
    const [map, setMap] = useState(null);
    const [createNewPotData, set_createNewPotData] = useState(null);
    const [mapStyles, setMapStyles] = useState(AppConfig.initialMapStylesMapSearch);

    const options = {
        /* restriction: {
            latLngBounds: AppConfig.taiwanBounds,
            strictBounds: false,
        }, */
        clickableIcons: true,//是否可點擊興趣點
        mapTypeControl: false,
        minZoom: 1,
        maxZoom: 30,
        disableDefaultUI: true,
        //styles: mapStyles,
    };
    const getUserLocation = () => {
        if (!navigator.geolocation) {
            alert("你的瀏覽器不支援 GPS 位置功能");
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const location = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                };
                setTimeout(() => {
                    map.setCenter(location);
                    map.setZoom(11);
                }, 1000);
                /* searchNearby({ latitude: location.lat, longitude: location.lng }, 5000, ["national_park", "hiking_area", "campground", "camping_cabin", "park", "playground"], 20, res => {
                    console.log("rrrrresss.....", res);
                    const _pots=res.map((v, k) => {
                        return {
                            rewilding_lat: v.location.latitude,
                            rewilding_lng: v.location.longitude,
                            rewilding_location: v.newAddr,
                            rewilding_name: v.displayName.text,
                            rewilding_photos: v.photoUrls.map((photoUrl) => { return { "rewilding_photos_path": photoUrl } }),
                            rewilding_place_id:v.id,
                        }
                    })
                    console.log("_pots",_pots);
                    map.setCenter(location);
                    map.setZoom(11);
                    set_pageState("pots");
                    set_pots(_pots);
                }); */
                /*  searchNearby(location,5000,"parking","",20,res=>{
                     console.log("rrrrresss.....",res);
                     res.forEach(v=>{
                         console.log(v,v.name,v.types)
                     })
                     
                     //fnArr.doCloseFn();
                    getPlaceDetails(res[0].place_id,_res=>{
                         console.log("detail",_res);
                     }) 
                 }); */
                /*  apiManager.fetchGet(`rewilding-searchNearby`, {
                     type: "",
                     lat: position.coords.latitude,
                     lng: position.coords.longitude,
                     radius: 5000,
                     language: "zh-TW"
                 }).then(res => {
                     console.log(res);
                     if (Array.isArray(res)) {
                         map.setCenter(location);
                         map.setZoom(11);
                         set_pots(res);
                     }
 
                 }).catch(err => {
                     console.log("....", err)
                 }) */
            },
            (err) => {
                if (rankRewilding[0]) {
                    map.setCenter({ lat: rankRewilding[0].rewilding_lat, lng: rankRewilding[0].rewilding_lng });
                    map.setZoom(11);
                    set_pots([rankRewilding[0]]);
                }
            }
        );
    };

    useEffect(() => {
        searchPredictions(keyword);
    }, [keyword]);
    useEffect(() => {
        console.log("predictions", predictions)
    }, [predictions]);

    const onLoad = useCallback(map => {
        setMap(map);
    }, []);

    const onUnmount = useCallback(map => {
        setMap(null);
    }, []);

    useEffect(() => {
        if (!map) return;
        function getMapBounds() {
            const bounds = map.getBounds();
            if (bounds) {
                const ne = bounds.getNorthEast(); // 右上角座標
                const sw = bounds.getSouthWest(); // 左下角座標
                const dy = ne.lat() - sw.lat(); // 緯度差距
                const diffR = dy * 111.32 * 1000 / 2;
                radius.current = diffR > 50000 ? 50000 : diffR;
            }
        }
        const listener2 = map.addListener('bounds_changed', () => {
            getMapBounds();
        });
        if (type === "tab0" || type === "selPot")
            getUserLocation();
        return () => {
            window.google.maps.event.removeListener(listener2);

        };
    }, [map]);
    useEffect(() => {
        if (pageState && map) {
            if (pageState === "main") {
            }
            else if (pageState === "selectPosition") {
                set_newPot(null);
            }
        }
    }, [pageState, map]);
    useEffect(() => {
        if (pots && map)
            updateMapMarker();
    }, [pots, map]);
    useEffect(() => {
        if (tags) {
            if (tags.length > 0) {
                const center = map.getCenter();  // 獲取地圖的中心點
                const lat = center.lat();        // 獲取緯度
                const lng = center.lng();        // 獲取經度
                const type = tags.map(v => v.type).join(",");
                console.log("tags", tags, radius.current, map.getCenter(), type)
                const fnArr = {}
                addModalType({
                    cls: "Loading", arg: { fnArr: fnArr }
                })
                /* searchNearby(center,radius.current,tags[0].type,tags[0].keyword,20,res=>{
                   console.log("rrrrresss.....",res);
                   res.forEach(v=>{
                       console.log(v,v.name,v.types)
                   })
                   
                   //fnArr.doCloseFn();
                  getPlaceDetails(res[0].place_id,_res=>{
                       console.log("detail",_res);
                       _res.photos[0].getUrl();
                       fnArr.doCloseFn();
                   }) 
               });*/
                apiManager.fetchGet(`rewilding-searchNearby`, {
                    type: type,
                    lat: lat,
                    lng: lng,
                    radius: radius.current,
                    language: "zh-TW"
                }).then(res => {
                    fnArr.doCloseFn();
                    console.log(res);
                    if (Array.isArray(res)) {
                        set_pots(res);
                    }
                }).catch(err => {
                    fnArr.doCloseFn();
                    set_pots([]);
                    console.log("....", err)
                })
                //rewilding-searchNearby
            }
            /*  const _potIndex = parseInt(Math.random() * result.length);
             setTimeout(() => {
                 set_potIndex(_potIndex);
                 console.log("set poit", _potIndex)
             }, 100); */
        }
    }, [tags]);
    useEffect(() => {
        if (pageState === "selectPosition") {
            set_menuVisiable(false);
            //setMapStyles({})
        }
        else {
            //設自動定位 跟放大pin
            //setMapStyles(AppConfig.initialMapStylesMapSearch)
            if (pots.length > 0 && potIndex >= 0) {
                if (pageState === "pots") {
                    const targetMarker = getPotMarker(potIndex);
                    if (previousSelectedMarker.current) {
                        previousSelectedMarker.current.setIcon({
                            url: `./map/pot.png`,
                            scaledSize: new window.google.maps.Size(32, 32),
                            anchor: new window.google.maps.Point(16, 32),
                        });
                    }
                    if (targetMarker) {
                        targetMarker.setIcon({
                            url: `./map/pot.png`,
                            scaledSize: new window.google.maps.Size(40, 40),
                            anchor: new window.google.maps.Point(20, 40),
                        });
                        previousSelectedMarker.current = targetMarker;
                    }
                }
                else if (pageState === "main") {

                }
                centerPot()
                set_menuVisiable(false);
            }
            else {
                set_menuVisiable(true);
            }
        }

    }, [potIndex, pageState]);
    function getPotMarker(potIndex) {
        const pot = pots[potIndex];
        const _marker = markersRef.current.find(v => v.id === potIndex);
        return _marker
    }
    function centerPot() {
        const pot = pots[0];
        if (pot) {
            map.setCenter({ lat: pot.rewilding_lat, lng: pot.rewilding_lng });
            map.setZoom(11);
        }
    }
    function handleMarkerClick(index) {
        set_potIndex(index);
        if (pageState === "main") {
            set_searchBarDefaultStr(pots[index].name);
        }
    }
    function updateMapMarker() {
        if (markersRef.current && markersRef.current.length > 0) {
            markersRef.current.forEach(marker => marker.setMap(null)); // 将每个marker从地图上移除
        }
        markersRef.current = [];
        if (pots.length === 0)
            return;
        let markers = pots.map((pot, index) => {
            const marker = new window.google.maps.Marker({
                id: index,
                map: map,
                position: { lat: pot.rewilding_lat, lng: pot.rewilding_lng },
                icon: {
                    url: `./map/pot.png`,
                    scaledSize: new window.google.maps.Size(32, 32), // 调整图标的大小
                    anchor: new window.google.maps.Point(16, 32),
                }
            });

            marker.addListener('click', () => {
                handleMarkerClick(index);
            });

            return marker;
        });
        markersRef.current = [...markers];
    }
    return (
        <div className={style.app}>
            <div className={style.main}>
                <GoogleMap
                    mapContainerStyle={{
                        width: '100%',
                        height: '100vh',
                    }}
                    center={AppConfig.mapCenter}
                    zoom={8}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                    options={options}
                    onClick={e => {
                        e.stop();//停止說明小視窗
                        console.log("mapp....", e, pageState)
                        if (pageState === "selectPosition") {
                            set_selectCustomPosition(e.latLng);
                            if (selectPositionMarker.current) {
                                selectPositionMarker.current.setMap(null);
                            }
                            selectPositionMarker.current = new window.google.maps.Marker({
                                map: map,
                                position: e.latLng,
                                icon: {
                                    url: `./assets/ui/positionFocus.png`,
                                    scaledSize: new window.google.maps.Size(26, 26), // 调整图标的大小
                                    anchor: new window.google.maps.Point(13, 13),
                                }
                            });
                            /* const geocoder = new window.google.maps.Geocoder();
                            console.log("geocoder",geocoder);
                            geocodeLatLng(geocoder,map,e.latLng); */
                            //https://nominatim.openstreetmap.org/reverse?format=json&lat=24.6102&lon=121.6640&zoom=18&addressdetails=1
                            /*  getAdministrativeArea(e.latLng.lat(),e.latLng.lng(),AppConfig.googleMapsApiKey,res=>{
                                 console.log(res);
                             }) */
                            /*  getGeocodingData("US").then(data => {
                                 console.log('Location:', data.location);
                                 console.log('Viewport:', data.viewport);
                                 map.setCenter(data.location);
                                 map.fitBounds(data.viewport);
                             })
                                 .catch(error => {
                                     console.error('Error:', error);
                                 }); */

                        }
                        else {
                            if (e.placeId)
                                getPlaceDetails(e.placeId, v => {
                                    console.log("detail", v);
                                    set_pots([
                                        {
                                            rewilding_lat: v.geometry.location.lat(),
                                            rewilding_lng: v.geometry.location.lng(),
                                            rewilding_location: getCountyAndTownForAddr(v.address_components),
                                            rewilding_name: v.name,
                                            rewilding_photos: v.photos.map((photoObj) => { return { "rewilding_photos_path": photoObj.getUrl() } }),
                                            rewilding_place_id: v.place_id,
                                        }
                                    ])
                                    set_pageState("pots");
                                    /* _res.photos[0].getUrl();
                                    fnArr.doCloseFn(); */
                                })
                            /*  apiManager.fetchGet(`rewilding/places/${e.placeId}`, {}, 1000).then(res => {
                                 console.log(res);
                                 map.setCenter({ lat: res.rewilding_lat, lng: res.rewilding_lng });
                                 set_pots([res]);
                                 set_pageState("pots");
                             }) */
                        }
                    }}
                >
                </GoogleMap>
            </div>
            <div className={`${style.keywordPanel} ${pageState === 'keyword' ? style.show : ''}`}>
                {predictions === null ?
                    <></>
                    :
                    (predictions.length === 0 && type !== "selPot") ?
                        <>
                            <div className={style.noResult}>
                                <img src="./assets/ui/noResult.png" />
                                <span>查無搜尋結果</span>
                            </div>
                            <div className={style.addPot}>
                                <span>我們的地圖上還沒有這酷地方！</span>
                                <div onClick={e => {
                                    addModalType({
                                        cls: "NewEvent", arg: {
                                            cb: () => {
                                            }
                                        }
                                    })
                                }}>
                                    <span>建立野放點</span>
                                    <ArrowForwardIosIcon fontSize='2' sx={{ color: "#000" }} />
                                </div>
                            </div>
                        </>
                        :
                        <div className={style.resultList}>
                            {
                                predictions.map((v, k) => {
                                    return <YStyle.Row gap="1rem" onClick={e => {
                                        apiManager.fetchGet(`rewilding/places/${v.place_id}`, {}, 1000).then(res => {
                                            console.log(res);
                                            map.setCenter({ lat: res.rewilding_lat, lng: res.rewilding_lng });
                                            set_pots([res]);
                                            set_pageState("pots");
                                        })
                                    }}>
                                        <YStyle.Label>
                                            <img src="./assets/ui/Location.png" />
                                        </YStyle.Label>
                                        <YStyle.Col gap=".3rem">
                                            <YStyle.Span size={17}>{v.structured_formatting.main_text}</YStyle.Span>
                                            <YStyle.Span size={13} fontWeight={400} color='#0000007f'>{v.structured_formatting.secondary_text}</YStyle.Span>
                                        </YStyle.Col>
                                    </YStyle.Row>
                                })
                            }
                        </div>
                }
            </div>
            <div className={`${style.keywordPanel} ${(pageState === 'pots' && pots.length === 0) ? style.show : ''}`}>
                <div className={style.noResult}>
                    <img src="./assets/ui/noResult.png" />
                    <span>查無搜尋結果</span>
                </div>
            </div>
            {pageState !== 'selectPosition' ?
                <div className={`${style.searchPanel} ${tags.length === 0 ? style.hasFilter : ""} ${(isFullScreen && pageState === "main") ? style.isFullScreen : ""}`}>
                    <div className={style.searchBarPanel}>
                        <div className={style.searchBar}>
                            {pageState === 'main' && potIndex === -1 ?
                                <>
                                    {type === "selPot" ?
                                        <IconButton onClick={e => {
                                            customEventManager.dispatch("selPot", null);
                                        }} >
                                            <KeyboardArrowLeftIcon />
                                        </IconButton>
                                        :
                                        <IconButton onClick={e => {
                                            set_pageState("keyword");
                                        }} >
                                            <SearchIcon />
                                        </IconButton>
                                    }
                                </>
                                :
                                <IconButton onClick={e => {
                                    set_pageState("main");
                                    set_potIndex(-1);
                                    set_searchBarDefaultStr(searchBarInitStr);
                                    set_tags([]);
                                }}>
                                    <KeyboardArrowLeftIcon />
                                </IconButton>
                            }
                            <input type='text' value={keyword} placeholder={searchBarDefaultStr}
                                onKeyUp={e => {
                                    if (e.code === "Enter")
                                        set_keyword(e.target.value)
                                }}
                                onFocus={e => {
                                    set_pageState("keyword");
                                }}
                                onChange={e => {
                                    set_keyword(e.target.value);
                                }} />
                            {keyword !== "" &&
                                <IconButton onClick={e => {
                                    set_keyword("");
                                }}>
                                    <CloseIcon />
                                </IconButton>
                            }
                            {/*                             {["main", "pots"].includes(pageState) ?
                                <IconButton onClick={e => {
                                    addModalType({
                                        cls: "SearchTagFilter", arg: {
                                            cb: (tags) => {
                                                console.log("----", tags)
                                                set_tags(tags);
                                                set_pageState("pots");
                                            }
                                        }
                                    })
                                }}>
                                    <TuneIcon />
                                </IconButton>
                                :
                                predictions.length === 0 ?
                                    <IconButton onClick={e => {
                                        set_keyword("");
                                    }}>
                                        <CloseIcon />
                                    </IconButton>
                                    :
                                    <></>
                            } */}
                        </div>
                        <div className={style.otherBtns}>
                            <img src="./assets/ui/addpot.svg" onClick={e => {
                                if (onPot)
                                    onPot();
                            }} />
                            <img src="./assets/ui/savepot.svg" onClick={e => {
                                if (onSave)
                                    onSave();
                            }} />
                        </div>
                    </div>
                    {tags.length > 0 ?
                        <div className={style.tags}>
                            {tags.map((tag, k) => <div key={k}>
                                <YStyle.Span size={15} fontWeight={400}>{tag.label}</YStyle.Span>
                                <Close onClick={e => {
                                    set_tags(props => props.filter(v => v != tag));
                                }} />
                            </div>)}
                        </div>
                        :
                        <div style={{ marginTop: ".4rem" }}></div>
                    }
                </div>
                :
                <IconButton className={style.selectPostionBackBtn} onClick={e => {
                    set_pageState("main");
                    if (selectPositionMarker.current)
                        selectPositionMarker.current.setMap(null);
                    set_selectCustomPosition(null);
                    set_createNewPotData(null);
                }}>
                    <img src="./assets/ui/back.png" />
                </IconButton>
            }
            {(pageState === "main" && type !== "selPot" && pots[potIndex]) &&
                <div className={style.potView}>
                    <PotViewItem onClick={(data) => {
                        addModalType({
                            cls: "PotDetail", arg: {
                                pot: data,
                                type: type,
                            }
                        })
                    }} pot={pots[potIndex]} type={type} />
                </div>
            }
            {((pageState === "pots" || type === "selPot") && pots.length > 0) &&
                <div className={style.swipe}>
                    <div className={style.resetPosition} onClick={getUserLocation} >
                        <img src="./assets/ui/resetPosition.svg" />
                    </div>
                    <PotSwipe pots={pots} type={type} potIndex={potIndex} set_potIndex={set_potIndex} onClick={data => {
                        addModalType({
                            cls: "PotDetail", arg: {
                                pot: data,
                                type: type,
                            }
                        })
                    }} />
                </div>
            }
            {pageState === "selectPosition" &&
                <>
                    <div className={style.selectPostionTip}>
                        拖曳地圖、點選地點
                    </div>
                    {newPot ?
                        <div className={style.createdPot}>
                            <YStyle.Col align="center" gap=".6rem" style={{ padding: "0 1rem", boxSizing: "border-box" }}>
                                <PotViewItem type="newPot" pot={newPot} />
                                <YStyle.BTN3 style={{ padding: ".8rem 2rem", borderRadius: "2rem" }}>
                                    <YStyle.Span size={17} onClick={e => {
                                        addModalType({
                                            cls: "NewEvent", arg: {
                                                pot: newPot,
                                                cb: () => {

                                                }
                                            }
                                        })
                                    }}>開始揪團</YStyle.Span>
                                </YStyle.BTN3>
                            </YStyle.Col>
                        </div>
                        :
                        <div className={style.selectPostionInputBox}>
                            <input value={selectCustomPosition ? `${selectCustomPosition.lat().toFixed(4)},${selectCustomPosition.lng().toFixed(4)}` : ""} placeholder='經度，緯度' type="text" />
                            <button disabled={!selectCustomPosition} className={allStyle.btnBlack2} onClick={e => {
                                addModalType({
                                    cls: "CreateNewPot", arg: {
                                        createNewPotData: createNewPotData,
                                        selectCustomPosition: selectCustomPosition,
                                        cb: (newPotObj) => {
                                            set_newPot(newPotObj);
                                        },
                                        onEdit: data => {
                                            set_createNewPotData(data);
                                        }
                                    }
                                })
                            }}>
                                確認
                            </button>
                        </div>
                    }

                </>
            }
        </div>
    );
}

export default MapSearch;
